<template>
  <div style="background-color: #2F3D4F; width: 100%; min-height: 860px; position: relative">
    <a-layout style="background-color: black">
      <a-layout>
        <div class="mask warning" v-show="isAddOrEdit">
          <div style=" position: absolute; top: 5px; right: 10px; cursor: pointer;" @click="cancel">
            <a-icon type="close" style="color: #fff; font-size: 24px;" />
          </div>
          <a-spin size="large" class="spin" v-show="isLoading"></a-spin>
          <div v-show="!isLoading">
            <a-form-model layout="inline">
              <a-form-model-item :label="$t('warningForm.template')">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="model" :placeholder="$t('warningForm.st')" dropdownClassName="selectOption" style="width: 280px" @change="handleModelChange">
                  <a-select-option value="-">
                    {{ $t('warningForm.none') }}
                  </a-select-option>
                  <a-select-option
                    v-for="warn in warningTemplateList"
                    :key="warn.id"
                    :value="warn.id"
                  >
                    {{ warn.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item>
                <a-button type="primary" v-show="isDelBtnShow" @click="delTemplate">{{ $t('warningForm.delete') }}</a-button>
              </a-form-model-item>
            </a-form-model>
            <a-form-model layout="inline" :model="form1" :rules="rules" ref="form1">
              <a-form-model-item :label="$t('device.warningName')" style="margin-right: 60px;" prop="name">
                <a-input v-model="form1.name" :placeholder="$t('warningForm.swmn')" style="width: 240px" />
              </a-form-model-item>
              <a-form-model-item :label="$t('device.warningType')" prop="dimension" style="margin-right: 60px;">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" :placeholder="$t('warning.swt')" v-model="form1.dimension" dropdownClassName="selectOption" style="width: 200px" >
                  <a-select-option value="DEVICE_STATUS">
                    {{ $t('warningForm.DEVICE_STATUS') }}
                  </a-select-option>
                  <a-select-option value="DEVICE_PARAMETER">
                    {{ $t('warningForm.DEVICE_PARAMETER') }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('warningForm.strategyConstraint')" prop="strategyConstraint" style="margin-right: 60px;">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" :placeholder="$t('warningForm.sct')" v-model="form1.strategyConstraint" dropdownClassName="selectOption" style="width: 200px">
                  <a-select-option value="AND">
                    {{ $t('warningForm.and') }}
                  </a-select-option>
                  <a-select-option value="OR">
                    {{ $t('warningForm.or') }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('menu.enabled')">
                <a-switch v-model="form1.enabled" :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" style="margin-top: 5px;" />
              </a-form-model-item>
            </a-form-model>
            <a-form-model :model="form2" ref="form2" :rules="rules">
              <a-form-model-item :label="$t('device.content')" prop="noticeContent">
                <a-input v-model="form2.noticeContent" :placeholder="$t('warningForm.encn')"></a-input>
              </a-form-model-item>
            </a-form-model>
            <a-form-model class="flex" :model="form3" :rules="rules" ref="form3">
              <a-form-model-item :label="$t('warningForm.noticeFrequency')" prop="noticeFrequency">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="form3.noticeFrequency" :placeholder="$t('warningForm.snf')" dropdownClassName="selectOption">
                  <a-select-option :value="1">
                    1
                  </a-select-option>
                  <a-select-option :value="3">
                    3
                  </a-select-option>
                  <a-select-option :value="6">
                    6
                  </a-select-option>
                  <a-select-option :value="12">
                    12
                  </a-select-option>
                  <a-select-option :value="24">
                    24
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('warningForm.warningLevel')" prop="warningLevel">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="form3.warningLevel" :placeholder="$t('warningForm.swl')" dropdownClassName="selectOption">
                  <a-select-option value="URGENT">
                    {{ $t('warningForm.URGENT') }}
                  </a-select-option>
                  <a-select-option value="IMPORTANT">
                    {{ $t('warningForm.IMPORTANT') }}
                  </a-select-option>
                  <a-select-option value="MINOR">
                    {{ $t('warningForm.MINOR') }}
                  </a-select-option>
                  <a-select-option value="PROMPT">
                    {{ $t('warningForm.PROMPT') }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('warningForm.effectiveTime')" required>
                <a-time-picker v-model="startTime" format="HH:mm"/>
                <span style="color: #fff; margin: 0 15px;">-</span>
                <a-time-picker v-model="endTime" format="HH:mm" />
              </a-form-model-item>
            </a-form-model>
            <a-form-model class="flex" :model="form3">
              <a-form-model-item :label="$t('warningForm.noticeCnt')" required>
                <a-input-number v-model="form3.noticeCnt" style="width: 80%;" />
              </a-form-model-item>
              <a-form-model-item :label="$t('warningForm.recoveryNotice')">
                <a-switch v-model="form3.recoveryNotice" :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" />
              </a-form-model-item>
              <div style="width: 96%;"></div>
            </a-form-model>
            <a-form-model :model="form4" :rules="rules" ref="form4">
              <a-form-model-item :label="$t('warningForm.warningRepeat')" prop="warningRepeat">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="form4.warningRepeat" mode="tags" style="width: 100%; color: #fff" :placeholder="$t('warningForm.swr')" dropdownClassName="selectOption">
                  <a-select-option value="1">{{ $t('warningForm.Sunday') }}</a-select-option>
                  <a-select-option value="2">{{ $t('warningForm.Monday') }}</a-select-option>
                  <a-select-option value="3">{{ $t('warningForm.Tuesday') }}</a-select-option>
                  <a-select-option value="4">{{ $t('warningForm.Wednesday') }}</a-select-option>
                  <a-select-option value="5">{{ $t('warningForm.Thursday') }}</a-select-option>
                  <a-select-option value="6">{{ $t('warningForm.Friday') }}</a-select-option>
                  <a-select-option value="7">{{ $t('warningForm.Saturday') }}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('warningForm.description')" prop="description">
                <a-input :placeholder="$t('warningForm.ed')" v-model="form4.description" style="padding: 0 10px; color: #fff" />
              </a-form-model-item>
              <div v-show="form1.dimension === 'DEVICE_PARAMETER'">
                <h3 class="tableTitle">{{ $t('warningForm.judgeCondition') }}: </h3>
                <a-button type="primary" @click="addFormTableItem">{{ $t('warningForm.addCondition') }}</a-button>
                <a-button v-show="deviceTableList.dataList.length > 1" type="primary" icon="undo" style="margin-left: 20px;" @click="undoData">{{ $t('warningForm.undo') }}</a-button>
                <table class="formTable">
                  <thead>
                    <tr>
                      <th>{{ $t('configuration.parameter') }}</th>
                      <th>{{ $t('warningForm.judge') }}</th>
                      <th>{{ $t('warningForm.valueType') }}</th>
                      <th>{{ $t('warningForm.value') }}</th>
                      <th>{{ $t('warningForm.monitorTime') }}</th>
                      <th>{{ $t('warningForm.duration') }}</th>
                      <th>{{ $t('common.operation') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(dataTableItem, index) in deviceTableList.dataList" :key="dataTableItem.id">
                      <td style="position: relative; width: 16%;">
                        <a-input :placeholder="$t('param.selectParam')" readOnly v-model="deviceTableList.dataList[index].dataName" style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff" @focus="handleFocus(index, 'dataList')" @blur="handleBlur(index, 'dataList')" />
                        <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                        <div style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;" v-show="deviceTableList.dataList[index].show" >
                          <ul style="list-style: none; height: 300px; overflow: auto">
                            <li v-for="data in deviceDataList" :key="data.code" @mousedown="selectData(data, index)" >
                              {{data[lang]}}
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td style="position: relative; width: 16%;">
                        <a-input :placeholder="$t('warningForm.judge')" readOnly v-model="deviceTableList.judgeList[index].value" style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff" @focus="handleFocus(index, 'judgeList')" @blur="handleBlur(index, 'judgeList')" />
                        <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                        <div style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;" v-show="deviceTableList.judgeList[index].show" >
                          <ul style="list-style: none">
                            <li v-for="(key, judge) of judgeList" :key="key" @mousedown="selectJudge(index, judge)" >
                              {{ judgeList[judge] }}
                              <!-- {{judgeList[judge]}} -->
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td style="position: relative; width: 16%;">
                        <a-input :placeholder="$t('warningForm.valueType')" readOnly v-model="deviceTableList.valueTypeList[index].value" style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff" @focus="handleFocus(index, 'valueTypeList')" @blur="handleBlur(index, 'valueTypeList')" />
                        <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                        <div style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;" v-show="deviceTableList.valueTypeList[index].show" >
                          <ul style="list-style: none">
                            <li v-for="(key, judge) of valueTypeList" :key="key" @mousedown="selectValueType(index, judge)" >
                              {{valueTypeList[judge]}}
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td style="width: 16%;">
                        <a-input-number id="inputNumber" style="width: 96%; margin: 0 2%;" v-model="deviceTableList.numberList[index].value" />
                      </td>
                      <td style="position: relative; width: 16%;">
                        <a-input :disabled="deviceTableList.valueTypeList[index].flag === 'ORIGIN'" :placeholder="$t('warningForm.monitorTime')" readOnly v-model="deviceTableList.duration[index].value" style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff" @focus="handleFocus(index, 'duration')" @blur="handleBlur(index, 'duration')" />
                        <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                        <div style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;" v-show="deviceTableList.duration[index].show" >
                          <ul style="list-style: none">
                            <li v-for="(key, judge) of duration" :key="key" @mousedown="selectDuration(index, judge)" >
                              {{duration[judge]}}
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td style="position: relative; width: 16%;">
                        <a-input :disabled="deviceTableList.valueTypeList[index].flag === 'ORIGIN'" :placeholder="$t('warningForm.duration')" readOnly v-model="deviceTableList.period[index].value" style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff" @focus="handleFocus(index, 'period')" @blur="handleBlur(index, 'period')" />
                        <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                        <div style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;" v-show="deviceTableList.period[index].show" >
                          <ul style="list-style: none">
                            <li v-for="judge in period" :key="judge" @mousedown="selectPeriod(index, judge)" >
                              {{judge}}
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td><a href="javascript:;" @click="removeFormTableItem(index)">{{ $t('buttons.delete') }}</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <a-form-model-item :label="$t('warningForm.mobile')" :required="!isDelBtnShow">
                <a-button type="primary" @click="addMobile">{{ $t('warningForm.addMobile') }}</a-button>
                <!-- <div class="ant-col ant-form-item-control-wrapper" v-for="(i, index) in mobiles" :key="index" style="margin-bottom: 15px">
                  <div class="wrapper">
                    <a-select option-label-prop="label" @focus="recordMobileIndex(index)" v-model="mobiles[index].reference" @select="handleSelectUsers" notFoundContent="暂无联系人" :getPopupContainer="(triggerNode) => triggerNode.parentNode" placeholder="请选择联系人" dropdownClassName="selectOption">
                      <a-select-option v-for="u in users" :key="u.id" :value="JSON.stringify([u.realName, u.username, u.organizationName])" :label="u.realName">
                        {{ u.realName }} - {{ u.username }} {{ u.organizationName ? '-' + u.organizationName : '' }}
                      </a-select-option>
                    </a-select>
                    <div style="margin: -4px 30px 0" class="ant-form-item-control" :class="{'has-error': i.error}">
                      <span class="ant-form-item-children">
                        <input data-v-30231798="" v-model="mobiles[index].mobile" placeholder="请输入通知手机号" type="text" class="ant-input" @blur="validate(i)">
                      </span>
                      <div class="ant-form-explain" style="white-space: nowrap; position: absolute" v-show="i.error">请输入通知手机号</div>
                    </div>
                    <a-input placeholder="请输入组织" v-model="mobiles[index].organizationName" style="width: 30%; margin-right: 30px" />
                    <div class="ant-form-item-control">
                      <label>是否接收短信：</label>
                      <a-switch v-model="mobiles[index].smsEnabled" />
                    </div>
                    <el-button type="primary" icon="el-icon-delete" circle style="position: relative; right: 120px; height: 40px" :disabled="mobiles.length === 1" @click="mobiles.splice(index, 1)" />
                  </div>
                </div> -->
                <table class="formTable">
                  <thead>
                    <tr>
                      <th>{{ $t('customer.realName') }}</th>
                      <th>{{ $t('warningForm.phoneNumber') }}</th>
                      <th>{{ $t('warningForm.userRole') }}</th>
                      <th>{{ $t('common.organization') }}</th>
                      <th>{{ $t('warningForm.SMSEnable') }}</th>
                      <th>{{ $t('warningForm.warningRecord') }}</th>
                      <th>{{ $t('common.operation') }}</th>
                    </tr>
                  </thead>
                  <tbody style="color: #ccc">
                    <tr v-for="(u, key) in userMap" :key="key">
                      <template v-if="u.editable">
                        <td><a-input @blur="f" style="width: 230px" v-model="u.realName" /></td>
                        <td><a-input @blur="f" style="width: 230px" v-model="u.username" /></td>
                        <td><a-input @blur="f" style="width: 230px" v-model="u.roleName" /></td>
                        <td><a-input @blur="f" style="width: 230px" v-model="u.organizationName" /></td>
                      </template>
                      <template v-else>
                        <td>{{ u.realName }}</td>
                        <td>{{ u.username }}</td>
                        <td>{{ u.roleName }}</td>
                        <td>{{ u.organizationName }}</td>
                      </template>
                      <td>
                        <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" @change="f" v-model="u.checked" />
                      </td>
                      <td>
                        <a-switch :checked-children="$t('common.open')" :un-checked-children="$t('common.close')" @change="f" v-model="u.queryEnabled" />
                      </td>
                      <td>
                        <a href="javascript:;" @click="editM(u)">{{ u.editable ? $t('buttons.save') : $t('buttons.edit') }}</a>
                        &nbsp;
                        &nbsp;
                        <a-popconfirm
                          style="padding: 0"
                          :title="$t('messages.ctrd')"
                          :ok-text="$t('common.okText')"
                          :cancel-text="$t('common.cancelText')"
                          :disabled="length === 1"
                          @confirm="removeU(u.id)"
                        >
                          <span :class="{ disabled: length === 1 }" @click="removeU(u.id)">{{ $t('buttons.delete') }}</span>
                        </a-popconfirm>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </a-form-model-item>
            </a-form-model>
            <a-form-model>
              <a-form-model-item>
                <a-button type="primary" :loading="isSubmitting" @click="submit">
                  {{ $t('buttons.save') }}
                </a-button>
                <a-button style="margin-left: 10px;" @click="cancel">
                  {{ $t('common.cancelText') }}
                </a-button>
                <a-button type="primary" style="float: right;" @click="submitTemplate">{{ $t('warningForm.submitTemplate') }}</a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
        </div>
        <a-layout-content
          v-show="!isAddOrEdit"
          :style="{ background: '#2F3D4F', padding:'20px', minHeight: '280px' }"
          ref="content"
          class="warning"
        >
          <h3 class="header">
            {{ $t('device.warning') }}
            <a-button v-if="isButtonShow" type="primary" style="float: right; margin-top: 15px" @click="showForm">{{ $t('warningForm.add') }}</a-button>
          </h3>
          <table>
            <thead>
              <tr>
                <th>{{ $t('device.warningID') }}</th>
                <th>{{ $t('device.warningName') }}</th>
                <th>{{ $t('device.warningType') }}</th>
                <th>{{ $t('device.warningDimension') }}</th>
                <th>{{ $t('device.content') }}</th>
                <th>{{ $t('device.mobile') }}</th>
                <th>{{ $t('common.operation') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-show="!isLoading">
                <tr v-for="warning in warningTableList" :key="warning.id">
                  <td>
                    {{warning.id}}
                  </td>
                  <td>
                    {{warning.name}}
                  </td>
                  <td>
                    {{ $t('device.deviceType') }}
                  </td>
                  <td>
                    {{ dimension[warning.dimension] }}
                  </td>
                  <td class="content">
                    <span>{{ warning.noticeContent }}</span>
                  </td>
                  <td>
                    {{ warning.noticeMobile }}
                  </td>
                  <td style="padding: 0 10px">
                    <a v-if="isButtonShow" href="javascript:;" @click="toggleToEdit(warning)">{{ $t('buttons.edit') }}</a>
                    &nbsp;
                    &nbsp;
                    <a-popconfirm
                      :title="$t('messages.ctrd')"
                      :ok-text="$t('common.okText')"
                      :cancel-text="$t('common.cancelText')"
                      @confirm="removeWarning(warning.id)"
                    >
                      <a href="javascript:;">{{ $t('buttons.delete') }}</a>
                    </a-popconfirm>
                  </td>
                </tr>
              </template>
              <tr v-if="warningTableList.length === 0">
                <td colspan="7" class="noData">{{ $t('device.empty') }}</td>
              </tr>
            </tbody>
          </table>
          <a-pagination
            show-less-items
            v-model="current"
            :total="total"
            :hideOnSinglePage="true"
            @change="handlePageChange"
          />
          <a-spin size="large" class="spin" v-show="isLoading"></a-spin>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import warningApi from '@/api/warning'
import moment from 'moment'
import { deviceApi, protocolApi } from '@/api/station'
import { getStationOrDeviceWarningList, getWarningTemplateList, deleteWarningTemplate, addWarningTemplate, updateWarningTemplate, addWarning, updateWarning, getWarning, delWarning } from '@/api/warning'
import { nanoid } from 'nanoid'
import { getProtocol } from '@/api/protocol'
import { getDict } from '@/api/dict'
import {
  searchCustomerList,
  getCustomerListByCompany,
  addCustomer,
  getCustomerById,
  updateCustomer
} from '@/api/customer'

export default {
  data() {
    return {
      model: undefined,
      stationName: '',
      sideMenuData: {},
      deviceTypes: [],
      defaultOpenKeys: [],
      defaultSelectedKeys: [],
      warningTableList: [],
      current: 1,
      total: 10,
      isLoading: false,
      isSubmitting: false,
      device: {},
      userMap: {},
      dimension: {
        'DEVICE_STATUS': this.$t('warningForm.deviceStatus'),
        'DEVICE_PARAMETER': this.$t('warningForm.deviceParamter')
      },
      isAddOrEdit: false,
      form1: {
        name: '',
        dimension: undefined,
        strategyConstraint: undefined,
        enabled: false
      },
      warningTemplateList: [],
      form2: {
        noticeContent: ''
      },
      form3: {
        noticeFrequency: undefined,
        warningLevel: undefined,
        noticeCnt: 3,
        recoveryNotice: true
      },
      form4: {
        description: '',
        warningRepeat: undefined
      },
      startTime: moment('00:00', 'HH:mm'),
      endTime: moment('00:00', 'HH:mm'),
      mobiles: [
        {
          mobile: '',
          name: '',
          smsEnabled: true,
          warningId: null,
          error: false
        }
      ],
      rules: {
        name: [
          {
            required: true,
            message: this.$t('warningForm.swm'),
            trigger: 'blur'
          },
          {
            max: 20,
            message: this.$t('warningForm.n') + 20,
            trigger: 'blur'
          }
        ],
        dimension: [
          {
            required: true,
            message: this.$t('warning.swt')
          }
        ],
        strategyConstraint: [
          {
            required: true,
            message: this.$t('warningForm.sct')
          }
        ],
        noticeContent: [
          {
            required: true,
            message: this.$t('warningForm.enc'),
            trigger: 'blur'
          },
          {
            max: 120,
            message: this.$t('warningForm.n') + 120,
            trigger: 'blur'
          }
        ],
        noticeFrequency: [
          {
            required: true,
            message: this.$t('warningForm.snf')
          }
        ],
        warningLevel: [
          {
            required: true,
            message: this.$t('warningForm.swl')
          }
        ],
        warningRepeat: [
          {
            required: true,
            message: this.$t('warningForm.swr')
          }
        ],
      },
      deviceTableList: {
        dataList: [{ id: nanoid(), dataName: '', show: false, code: '', warningId: undefined }],
        judgeList: [{ value: '', show: false, flag: undefined }],
        valueTypeList: [{ value: '', show: false, flag: undefined }],
        numberList: [{ value: 0 }],
        duration: [{ value: '', show: false, flag: undefined }],
        period: [{ value: '', show: false, flag: undefined}]
      },
      deviceDataList: [],
      judgeList: {
        EQ: '=',
        NE: '≠',
        GT: '>',
        GE: '≥',
        LT: '<',
        LE: '≤'
      },
      valueTypeList: {
        AVERAGE: this.$t('warningForm.AVERAGE'),
        MAX: this.$t('warningForm.MAX'),
        MIN: this.$t('warningForm.MIN'),
        SUM: this.$t('warningForm.SUM'),
        ORIGIN: this.$t('warningForm.ORIGIN')
      },
      duration: {
        5: '5' + this.$t('warningForm.minutes'),
        20: '20' + this.$t('warningForm.minutes'),
        60: '60' + this.$t('warningForm.minutes')
      },
      period: [1, 2, 3, 4, 5],
      isButtonShow: false
    }
  },
  computed: {
    isDelBtnShow () {
      return this.model !== '-' && this.model !== undefined
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    this.code = this.$route.query.code
    this.driverType = this.$route.query.driver
    this.protocolCode = this.$route.query.pc
    let a = this.getAuthorities('/equipment/group');
    this.isButtonShow = !!a.find(auth => auth.code === 'warning:insert')
    this.getDict()
    this.getCustomerInfo()
  },
  async mounted() {
    this.getWarningTableList()
    this.getDeviceDataList()
  },
  methods: {
    translate() {
      this.dimension = {
        'DEVICE_STATUS': this.$t('warningForm.deviceStatus'),
        'DEVICE_PARAMETER': this.$t('warningForm.deviceParamter')
      }
      this.rules = {
        name: [
          {
            required: true,
            message: this.$t('warningForm.swm'),
            trigger: 'blur'
          },
          {
            max: 20,
            message: this.$t('warningForm.n') + 20,
            trigger: 'blur'
          }
        ],
        dimension: [
          {
            required: true,
            message: this.$t('warning.swt')
          }
        ],
        strategyConstraint: [
          {
            required: true,
            message: this.$t('warningForm.sct')
          }
        ],
        noticeContent: [
          {
            required: true,
            message: this.$t('warningForm.enc'),
            trigger: 'blur'
          },
          {
            max: 120,
            message: this.$t('warningForm.n') + 120,
            trigger: 'blur'
          }
        ],
        noticeFrequency: [
          {
            required: true,
            message: this.$t('warningForm.snf')
          }
        ],
        warningLevel: [
          {
            required: true,
            message: this.$t('warningForm.swl')
          }
        ],
        warningRepeat: [
          {
            required: true,
            message: this.$t('warningForm.swr')
          }
        ]
      }
      this.valueTypeList = {
        AVERAGE: this.$t('warningForm.AVERAGE'),
        MAX: this.$t('warningForm.MAX'),
        MIN: this.$t('warningForm.MIN'),
        SUM: this.$t('warningForm.SUM'),
        ORIGIN: this.$t('warningForm.ORIGIN')
      }
      this.duration = {
        5: '5' + this.$t('warningForm.minutes'),
        20: '20' + this.$t('warningForm.minutes'),
        60: '60' + this.$t('warningForm.minutes')
      }
    },
    f() {
      this.$forceUpdate()
    },
    async getCustomerInfo() {
      try {
        const { data } = await getCustomerById(this.$route.query.ci)
        this.users = []
        const map = {}
        data.followers?.forEach(i => {
          i.roleName = this.$t('common.followers')
          i.checked = false
          map[i.id] = i
        })
        data.salesmen?.forEach(i => {
          i.roleName = this.$t('common.salesMen')
          i.checked = false
          map[i.id] = i
        })
        data.serviceMans?.forEach(i => {
          i.roleName = this.$t('common.serviceMen')
          i.checked = false
          map[i.id] = i
        })
        data.users?.forEach(i => {
          i.roleName = this.$t('common.user')
          i.checked = false
          map[i.id] = i
        })
        for (let key in map) {
          this.users.push(map[key])
        }
        this.userMap = map
        this.originUserMap = JSON.parse(JSON.stringify(map))
        this.length = this.users.length
      } catch {}
    },
    moment,
    editM(u) {
      u.editable = !u.editable
      this.$forceUpdate()
    },
    removeU(id) {
      if (this.length === 1) return
      delete this.userMap[id]
      this.length--
      this.$forceUpdate()
    },
    async getWarningTableList() {
      this.isLoading = true
      try {
        const { data } = await getStationOrDeviceWarningList({
          current: this.current,
          pageSize: 10,
          warningName: '',
          warningDimension: '',
          targetResource: this.$route.query.id,
          warningType: 'DEVICE'
        })
        this.total = data.total
        this.warningTableList = data.records.map(r => {
          r.noticeMobile = '';
          (r.mobiles || []).forEach(m => {
            if (m.smsEnabled || m.queryEnabled) {
              r.noticeMobile += m.mobile + ', '
            }
          })
          r.noticeMobile = r.noticeMobile.slice(0, -2)
          return r
        })
      } catch(err) {
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },
    async getDeviceDataList() {
      try {
        const { data: { points } } = await getProtocol(this.protocolCode)
        this.deviceDataList = points.filter(d => d.dataWrite !== 2).map(p => {
          (p.details || []).forEach(d => {
            if (d.locale === 'zh-CN') {
              p.zh = d.name
            }
            if (d.locale === 'en-US') {
              p.en = d.name
            }
          })
          if (!p.zh) {
            p.zh = p.name
          }
          if (!p.en) {
            p.en = p.zh
          }
          return p
        })
      } catch(err) {
        console.error(err)
      }
    },
    handleFocus (index, type) {
      this.deviceTableList[type][index].show = true
    },
    handleBlur (index, type) {
      this.deviceTableList[type][index].show = false
    },
    selectData (data, index) {
      this.deviceTableList.dataList[index].dataName = data.name
      this.deviceTableList.dataList[index].code = data.code
    },
    selectJudge (index, judge) {
      this.deviceTableList.judgeList[index].value = this.judgeList[judge]
      this.deviceTableList.judgeList[index].flag = judge
    },
    selectValueType(index, type) {
      this.deviceTableList.valueTypeList[index].value = this.valueTypeList[type]
      this.deviceTableList.valueTypeList[index].flag = type
      this.$forceUpdate()
    },
    selectDuration(index, type) {
      this.deviceTableList.duration[index].value = this.duration[type]
      this.deviceTableList.duration[index].flag = type
    },
    selectPeriod(index, type) {
      this.deviceTableList.period[index].value = type
      this.deviceTableList.period[index].flag = type
    },
    addMobile() {
      const id = nanoid()
      this.userMap[id] = {
        checked: false,
        id,
        organizationName: '',
        realName: '',
        roleName: '',
        username: '',
        editable: true
      }
      this.length++
      this.$forceUpdate()
    },
    undo() {
      if(!this.mobiles[this.mobiles.length - 1].mobile && this.mobiles.length === 1) {
        return this.$message.warning(this.$t('warningForm.ealopn'))
      }
      if(!this.mobiles[this.mobiles.length - 1].mobile && !this.mobiles[this.mobiles.length - 1].name) {
        this.mobiles.splice(this.mobiles.length - 1, 1)
      } else {
        this.mobiles[this.mobiles.length - 1].mobile = ''
        this.mobiles[this.mobiles.length - 1].name = ''
        this.$forceUpdate()
      }
    },
    validate(i) {
      if(!i.mobile) {
        i.error = true
        return false
      } else {
        i.error = false
        return true
      }
    },
    addFormTableItem() {
      this.deviceTableList.dataList.push({
        id: nanoid(),
        dataName: '',
        show: false
      })
      this.deviceTableList.judgeList.push({
        value: '',
        show: false
      })
      this.deviceTableList.valueTypeList.push({
        value: '',
        show: false
      })
      this.deviceTableList.duration.push({
        value: '',
        show: false
      })
      this.deviceTableList.period.push({
        value: '',
        show: false
      })
      this.deviceTableList.numberList.push({
        value: 0
      })
    },
    async submit() {
      let formValid = false
      for(let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].validate(valid => {
          if(valid) {
            formValid = true
          }
        })
      }
      let count = 0
      const mobiles = []
      // for (let j = 0; j < this.mobiles.length; j++) {
      //   const i = this.mobiles[j]
      //   const mobilesValid = this.validate(i)
      //   if(!mobilesValid) {
      //     count++
      //     break
      //   } else {
      //     const id = this.id || i.warningId
      //     mobiles.push({
      //       mobile: i.mobile,
      //       name: i.name,
      //       smsEnabled: true,
      //       warningId: id,
      //       error: false
      //     })
      //   }
      // }
      for (let key in this.userMap) {
        const k = this.userMap[key]
        mobiles.push({
          warningId: this.id,
          smsEnabled: this.userMap[key].checked,
          organizationName: this.userMap[key].organizationName,
          mobile: this.userMap[key].username,
          name: this.userMap[key].realName,
          roleName: k.roleName,
          queryEnabled: !!k.queryEnabled
        })
      }
      const warningRepeat = this.form4.warningRepeat.join(',')
      if(count === 0 && formValid) {
        this.isSubmitting = true
        const effectiveTime = moment(+this.startTime).format('HH:mm') + '-' + moment(+this.endTime).format('HH:mm')
        const strategies = []
        if(this.form1.dimension === 'DEVICE_PARAMETER') {
          this.deviceTableList.dataList.forEach((data, index) => {
            const param = {
              name: data.dataName,
              code: data.code,
              valueType: this.deviceTableList.valueTypeList[index].flag,
              condition: this.deviceTableList.judgeList[index].flag,
              targetValue: this.deviceTableList.numberList[index].value + '',
              duration: this.deviceTableList.duration[index].flag,
              period: this.deviceTableList.period[index].flag
            }
            if(typeof data.id === 'number') {
              param.id = data.id
            }
            strategies.push(param)
          })
        }
        if(this.form1.dimension === 'DEVICE_STATUS') {
          strategies[0] = {
            name: this.$t('warningForm.offline'),
            code: 'offline',
            valueType: 'ORIGIN',
            condition: 'EQ',
            targetValue: '3',
            duration: 20,
            period: 5
          }
        }
        const params = {
          ...this.form1,
          ...this.form2,
          ...this.form3,
          ...this.form4,
          type: 'DEVICE',
          targetResource: this.$route.query.id,
          scope: null,
          effectiveTime,
          warningRepeat,
          strategies,
          mobiles
        }
        // console.log(params);
        // console.log(params);
        try {
         if(this.id) {
            params.id = this.id
            const { message } = await updateWarning(params)
            this.$message.success(message)
          } else {
            const { message } = await addWarning(params)
            this.$message.success(message)
          }
          this.cancel()
          this.getWarningTableList()
        } catch(err) {
          console.error(err)
        } finally {
          this.isSubmitting = false
        }
      }
    },
    undoData () {
      let flag = false
      for (let key in this.deviceTableList) {
        const value = this.deviceTableList[key].at(-1).value || this.deviceTableList[key].at(-1).code
        if (value) {
          flag = true
          this.deviceTableList[key].at(-1).value = ''
          if (this.deviceTableList[key].at(-1).code) {
            this.deviceTableList[key].at(-1).code = ''
            this.deviceTableList[key].at(-1).dataName = ''
          }
        }
      }
      if (!flag) {
        for (let key in this.deviceTableList) {
          this.deviceTableList[key].pop()
        }
      }
    },
    cancel() {
      for(let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].resetFields()
      }
      this.mobiles = [
        {
          mobile: '',
          name: '',
          smsEnabled: true,
          warningId: null,
          error: false
        }
      ]
      this.form4.description = ''
      this.form1.enabled = false
      this.form4.warningRepeat = undefined
      this.id = undefined
      this.isAddOrEdit = false
      this.model = undefined
      this.deviceTableList = {
        dataList: [{ id: nanoid(), dataName: '', show: false, code: '', warningId: undefined }],
        judgeList: [{ value: '', show: false, flag: undefined }],
        valueTypeList: [{ value: '', show: false, flag: undefined }],
        numberList: [{ value: '' }],
        duration: [{ value: '', show: false, flag: undefined }],
        period: [{ value: '', show: false, flag: undefined }]
      }
      this.isLoading = false
      this.getCustomerInfo()
    },
    async removeWarning(id) {
      try {
        await delWarning(id)
        this.getWarningTableList()
      } catch(err) {
        console.error(err)
      }
    },
    async getDict() {
      const { data } = await getDict('zh-CN', 'deviceType')
      this.deviceTypeMap = {}
      data.content.forEach(c => {
        this.deviceTypeMap[c.value] = c.text
      })
    },
    async toggleToEdit(warning) {
      this.isAddOrEdit = true
      this.isLoading = true
      this.id = warning.id
      const { data } = await getWarningTemplateList(this.deviceTypeMap[this.$route.query.type])
      this.warningTemplateList = data
      try {
        const { data } = await getWarning(this.id)
        for(let i = 1; i < 5; i++) {
          for(let key in this[`form${i}`]) {
            this[`form${i}`][key] = warning[key]
          }
        }
        const time = warning.effectiveTime.split('-')
        this.startTime = moment(time[0], 'HH:mm')
        this.endTime = moment(time[1], 'HH:mm')
        // this.mobiles = warning.mobiles
        data.mobiles.forEach(m => {
          const u = this.users.find(u => u.username === m.mobile)
          if (u) {
            this.userMap[u.id].checked = m.smsEnabled
            this.userMap[u.id].queryEnabled = m.queryEnabled
          } else {
            this.length++
            const id = nanoid()
            this.userMap[id] = {
              id,
              checked: m.smsEnabled,
              organizationName: m.organizationName,
              realName: m.name,
              roleName: m.roleName,
              username: m.mobile,
              queryEnabled: m.queryEnabled
            }
          }
        })
        this.form4.warningRepeat = warning.warningRepeat.split(',')
        if(data.strategies?.[0].name === '离线指标') {
          this.isLoading = false
          return
        }
        const deviceTableList = {
          dataList: [],
          judgeList: [],
          numberList: [],
          valueTypeList: [],
          duration: [],
          period: []
        }
        data.strategies.forEach(strategie => {
          deviceTableList.dataList.push({
            id: strategie.id,
            dataName: strategie.name,
            code: strategie.code,
            show: false
          })
          deviceTableList.judgeList.push({
            value: this.judgeList[strategie.condition],
            flag: strategie.condition,
            show: false
          })
          deviceTableList.numberList.push({
            value: strategie.targetValue
          })
          deviceTableList.valueTypeList.push({
            value: this.valueTypeList[strategie.valueType],
            flag: strategie.valueType,
            show: false
          })
          deviceTableList.duration.push({
            value: this.duration[strategie.duration],
            flag: strategie.duration,
            show: false
          })
          deviceTableList.period.push({
            value: this.period[strategie.period - 1],
            flag: strategie.period,
            show: false
          })
        })
        this.deviceTableList = deviceTableList
      } catch(err) {
        console.error(err)
      }
      this.isLoading = false
    },
    toggleDevice(device) {
      const i = this.deviceList.find(item => item.deviceCode === device.deviceCode)
      this.device = i
      this.getDeviceDataList()
      this.getWarningTableList()
      this.cancel()
    },
    async showForm () {
      const { data } = await getWarningTemplateList(this.deviceTypeMap[this.$route.query.type])
      this.warningTemplateList = data
      this.isAddOrEdit = true
    },
    handlePageChange(page) {
      this.current = page
      this.getWarningTableList()
    },
    handleModelChange (value) {
      this.userMap = JSON.parse(JSON.stringify(this.originUserMap))
      if (value !== '-') {
        const warning = this.warningTemplateList.find(warn => warn.id === value)
        for(let i = 1; i < 5; i++) {
          for(let key in this[`form${i}`]) {
            this[`form${i}`][key] = warning[key]
          }
        }
        
        const time = warning.effectiveTime.split('-')
        this.startTime = moment(time[0], 'HH:mm')
        this.endTime = moment(time[1], 'HH:mm')
        warning.mobiles.forEach(m => {
          const u = this.users.find(u => u.username === m.mobile)
          if (u) {
            this.userMap[u.id].checked = m.smsEnabled
            this.userMap[u.id].queryEnabled = m.queryEnabled
          } else {
            this.length++
            const id = nanoid()
            this.userMap[id] = {
              id,
              checked: true,
              organizationName: m.organizationName,
              realName: m.name,
              roleName: m.roleName,
              username: m.mobile,
              queryEnabled: m.queryEnabled
            }
          }
        })
        this.form4.warningRepeat = warning.warningRepeat.split(',')
        if (warning.strategy && warning.strategy.length > 0) {
          if(warning.strategy?.[0].name === this.$t('warningForm.offline')) {
            return
          }
          const deviceTableList = {
            dataList: [],
            judgeList: [],
            numberList: [],
            valueTypeList: [],
            duration: [],
            period: []
          }
          warning.strategy.forEach(strategie => {
            deviceTableList.dataList.push({
              id: strategie.id,
              dataName: strategie.name,
              code: strategie.code,
              show: false
            })
            deviceTableList.judgeList.push({
              value: this.judgeList[strategie.condition],
              flag: strategie.condition,
              show: false
            })
            deviceTableList.numberList.push({
              value: strategie.targetValue
            })
            deviceTableList.valueTypeList.push({
              value: this.valueTypeList[strategie.valueType],
              flag: strategie.valueType,
              show: false
            })
            deviceTableList.duration.push({
              value: this.duration[strategie.duration],
              flag: strategie.duration,
              show: false
            })
            deviceTableList.period.push({
              value: this.period[strategie.period - 1],
              flag: strategie.period,
              show: false
            })
          })
          this.deviceTableList = deviceTableList
        }
      } else {
        for(let i = 1; i < 5; i++) {
          this.$refs[`form${i}`].resetFields()
        }
        this.mobiles = [
          {
            mobile: '',
            name: '',
            smsEnabled: true,
            warningId: null,
            error: false
          }
        ]
        this.form4.description = ''
        this.form1.enabled = false
        this.form4.warningRepeat = undefined
        this.id = undefined
        this.model = undefined
        this.deviceTableList = {
          dataList: [{ id: nanoid(), dataName: '', show: false, code: '', warningId: undefined }],
          judgeList: [{ value: '', show: false, flag: undefined }],
          valueTypeList: [{ value: '', show: false, flag: undefined }],
          numberList: [{ value: '' }],
          duration: [{ value: '', show: false, flag: undefined }],
          period: [{ value: '', show: false, flag: undefined}]
        }
      }
    },
    async submitTemplate () {
      let formValid = false
      for(let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].validate(valid => {
          if(valid) {
            formValid = true
          }
        })
      }
      const effectiveTime = moment(+this.startTime).format('HH:mm') + '-' + moment(+this.endTime).format('HH:mm')
      const warningRepeat = this.form4.warningRepeat.join(',')
      const strategy = []
      if(this.form1.dimension === 'DEVICE_PARAMETER') {
        this.deviceTableList.dataList.forEach((data, index) => {
          const param = {
            name: data.dataName,
            code: data.code,
            valueType: this.deviceTableList.valueTypeList[index].flag,
            condition: this.deviceTableList.judgeList[index].flag,
            targetValue: this.deviceTableList.numberList[index].value + '',
            duration: this.deviceTableList.duration[index].flag,
            period: this.deviceTableList.period[index].flag
          }
          if(typeof data.id === 'number') {
            param.id = data.id
          }
          strategy.push(param)
        })
      }
      if(this.form1.dimension === 'DEVICE_STATUS') {
        strategy[0] = {
          name: this.$t('warningForm.offline'),
          code: 'offline',
          valueType: 'ORIGIN',
          condition: 'EQ',
          targetValue: '3',
          duration: 20,
          period: 5
        }
      }
      if(formValid) {
        const mobiles = []
        for (let key in this.userMap) {
          const k = this.userMap[key]
          if (k.checked || k.queryEnabled) {
            mobiles.push({
              warningId: this.id,
              smsEnabled: !!k.checked,
              organizationName: this.userMap[key].organizationName,
              mobile: this.userMap[key].username,
              name: this.userMap[key].realName,
              roleName: k.roleName,
              queryEnabled: !!k.queryEnabled
            })
          }
        }
        const params = {
          name: this.form1.name,
          description: this.form4.description,
          type: 'DEVICE',
          dimension: this.form1.dimension,
          targetType: this.deviceTypeMap[this.$route.query.type],
          sort: 1,
          strategyConstraint: this.form1.strategyConstraint,
          noticeContent: this.form2.noticeContent,
          noticeFrequency: this.form3.noticeFrequency,
          warningLevel: this.form3.warningLevel,
          noticeCnt: this.form3.noticeCnt,
          recoveryNotice: this.form3.recoveryNotice,
          warningRepeat,
          effectiveTime,
          enabled: this.form1.enabled,
          strategy,
          mobiles
        }
        try {
           if (typeof this.model === 'number') {
            params.id = this.model
            const { message } = await updateWarningTemplate(params)
            this.$message.success(message)
          } else {
            const i = this.warningTemplateList.find(item => item.name === this.form1.name)
            if (i) {
              return this.$message.warn(this.$t('warningForm.exitedTemplate'))
            }
            const { message } = await addWarningTemplate(params)
            this.$message.success(message)
          }
          this.showForm()
        } catch (err) {
          console.error(err)
        }
      }
    },
    async delTemplate () {
      try {
        const { message } = await deleteWarningTemplate(this.model)
        this.$message.success(message)
        await this.showForm()
        for(let i = 1; i < 5; i++) {
          this.$refs[`form${i}`].resetFields()
        }
        this.mobiles = [
          {
            mobile: '',
            name: '',
            smsEnabled: true,
            warningId: null,
            error: false
          }
        ]
        this.form4.description = ''
        this.form1.enabled = false
        this.form4.warningRepeat = undefined
        this.id = undefined
        this.model = undefined
      } catch (err) {
        console.error(err)
      }
    },
    removeFormTableItem (index) {
      for (const key in this.deviceTableList) {
        this.deviceTableList[key].splice(index, 1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.ant-layout-has-sider {
  margin: 20px;
}
.stationName {
  height: auto;
  background-color: #001529;
  margin: 0;
  padding: 0;
  color: #fff;
  line-height: 40px;
  font-size: 22px;
  padding-left: 24px;
}
.warning {
  position: relative;
  background-color: #2F3D4F;
  height: auto;
  &.ant-layout-content {
    min-height: 860px !important;
  }
  ul {
    width: 100%;
    li {
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
    }
    li:hover {
      background-color: #A7ADB5;
    }
  }
  form {
    width: 90%;
    margin: 20px auto;
    h3.tableTitle {
      font-size: 15px;
      color: #bfbfbf;
      margin-bottom: 15px;
    }
    input.ant-input {
      color: #fff;
      padding: 0 10px;
    }
  }
  .spin {
    position: absolute;
    top: 300px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }
  .header {
    width: 95%;
    margin: auto;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    color: #F8FCED;
    border-bottom: 1px solid #1976CF;
  }
  table {
    width: 100%;
    border: 1px solid #4A5665;
    color: #A7ADB5;
    margin-top: 24px;
    margin-bottom: 24px;
    th,
    td {
      height: 60px;
      text-align: center;
    }
    th {
      border-right: 1px solid #5B6574;
      background-color: #485464;
      padding: 0 10px;
    }
    td {
      border-top: 1px solid #445161;
      border-right: 1px solid #445161;
      &.content {
        width: 300px;
        overflow: hidden;
        box-sizing: border-box;
        span {
          display: block;
          max-width: 280px;
          padding-left: 10px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .formTable th,
  .formTable td {
    height: 40px;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    .ant-form-item {
      width: 30%
    }
  }
}
.warning .ant-input,
.warning .ant-select-selection__placeholder.ant-input,
.warning .ant-calendar-picker-input.ant-input {
  background-color: #2F3D4F;
}
.warning .ant-input[data-v-020d5318], .warning .ant-select-selection__placeholder.ant-input[data-v-020d5318], .warning .ant-calendar-picker-input.ant-input[data-v-020d5318] {
  padding: 0 10px;
  color: #fff;
}
.ant-menu-item {
  padding-left: 30px !important;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item {
  height: auto;
  display: flex;
  align-items: center;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item span {
  white-space: normal;
  word-break: break-all;
  flex: 1;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item span.more {
  line-height: 20px;
}
.ant-col .wrapper {
  display: flex;
  justify-content: space-between;
  div {
    width: 30%;
    label {
      color: #bfbfbf;
    }
  }
}
.formTable span:not(.disabled) {
  color: #1890ff;
  cursor: pointer;
}
span.disabled {
  color: #999;
  cursor: not-allowed !important;
}
</style>